import { useState, useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import Util, { Data } from 'service/util';

import DatePicker from 'react-datepicker';
import ServiceWeekdayPicker from 'component/service/ServiceWeekdayPicker';

const DataGridServiceRow = ({service, sort, removeRow, ...props}) =>
{
  const ori_worker = service.worker;

  const [company,   setCompany   ] = useState(service.company);
  const [reg_dtm,   setRegDate   ] = useState(service.reg_dtm);
  const [start_dtm, setStartDate ] = useState(service.start_dtm);
  const [end_dtm,   setEndDate   ] = useState(service.end_dtm);
  const [srv_plan,  setPlan      ] = useState(service.srv_plan);
  const [srv_dis,   setDistrict  ] = useState(service.srv_dis);
  const [srv_loc,   setLocId     ] = useState(service.srv_loc);
  const [srv_floor, setFloor     ] = useState(service.srv_floor);
  const [srv_psn,   setPsn       ] = useState(service.srv_psn);
  const [fee,       setFee       ] = useState(service.fee);
  const [rotation,  setRotation  ] = useState(service.rotation);
  const [extra_fee, setExtraFee  ] = useState(service.extra_fee);
  const [weekday1,  setWeekday1  ] = useState(service.weekday1);
  const [weekday2,  setWeekday2  ] = useState(service.weekday2);
  const [weekday3,  setWeekday3  ] = useState(service.weekday3);
  const [waxing,    setWaxing    ] = useState(service.waxing);
  const [worker,    setWorker    ] = useState(service.worker);

  const setWeekday = (d1, d2, d3) => {
    setWeekday1(d1);
    setWeekday2(d2);
    setWeekday3(d3);
  }

  useEffect(() => {
    switch (srv_plan)
    {
      case 'A':
        setWeekday1(0);
      case 'C':           /* deliberate fall-through */
        setWeekday2(0);
        setWeekday3(0);
        break;
    }
  }, [srv_plan]);

  useEffect(() => {
    service.company   = company;
    service.reg_dtm   = reg_dtm;
    service.start_dtm = start_dtm;
    service.end_dtm   = end_dtm;
    service.srv_plan  = srv_plan;
    service.srv_dis   = srv_dis;
    service.srv_loc   = srv_loc;
    service.srv_floor = srv_floor;
    service.srv_psn   = srv_psn;
    service.fee       = fee;
    service.rotation  = rotation;
    service.extra_fee = extra_fee;
    service.weekday1  = weekday1;
    service.weekday2  = weekday2;
    service.weekday3  = weekday3;
    service.waxing    = waxing;
    service.worker    = worker;
  }, [
    company, reg_dtm, start_dtm, end_dtm,
    srv_plan, srv_dis, srv_loc, srv_floor, srv_psn,
    fee, rotation, extra_fee,
    weekday1, weekday2, weekday3,
    waxing, worker
  ]);

  useEffect(() => {
    sort();
  }, [start_dtm]);

  return (
    <tr>
      <td className="col-srvadv-btn">
        <button className="btn small red" type="button" onClick={removeRow} title="移除">
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </td>
      <td className="col-srvadv-company">
        <select value={company} onChange={ e=>setCompany(e.target.value) }>
          { Data.company.map(com =>
            <option key={com.cd} value={com.cd}>{com.cd} - {com.name}</option>
          )}
        </select>
      </td>
      <td className="col-srvadv-reg-date">
        <DatePicker selected={ reg_dtm } onChange={d=>setRegDate(d)} dateFormat="yyyy-MM-dd" />
      </td>
      <td className="col-srvadv-start-date">
        <DatePicker selected={ start_dtm } onChange={d=>setStartDate(d)} dateFormat="yyyy-MM-dd" />
      </td>
      <td className="col-srvadv-end-date">
        <DatePicker selected={ end_dtm } onChange={d=>setEndDate(d)} dateFormat="yyyy-MM-dd" />
      </td>
      <td className="col-srvadv-plan">
        <select value={srv_plan} onChange={ e=>setPlan(e.target.value) }>
          { Data.plan.map(p =>
            <option key={p} value={p}>{ p }</option>
          )}
        </select>
      </td>
      <td className="col-srvadv-district">
        <select value={srv_dis} onChange={ e=>setDistrict(e.target.value) }>
          { Data.district.map(d =>
            <option key={d.cd} value={d.cd}>{d.cd} - {d.name}</option>
          )}
        </select>
      </td>
      <td className="col-srvadv-location">
        <select value={srv_loc} onChange={ e=>setLocId(e.target.value) }>
          { Data.location.filter(x => x.srv_dis == srv_dis).map(l =>
            <option key={l.srv_loc} value={l.srv_loc}>{l.srv_dis}{l.srv_loc} - {l.name_zh} {l.name_en}</option>
          )}
        </select>
      </td>
      <td className="col-srvadv-floor">
        <input type="text" value={ srv_floor } onChange={ e=>setFloor(e.target.value) } />
      </td>
      <td className="col-srvadv-psn">
        <input type="text" value={ srv_psn } onChange={ e=>setPsn(e.target.value) } />
      </td>
      <td className="col-srvadv-fee">
        <input type="number" value={ fee } onChange={ e=>setFee(parseFloat(e.target.value)) } />
      </td>
      <td className="col-srvadv-rotation">
        <input type="text" value={ rotation } onChange={ e=>setRotation(e.target.value) }/>
      </td>
      <td className="col-srvadv-extra-fee">
        <input type="number" value={ extra_fee } onChange={ e=>setExtraFee(parseFloat(e.target.value)) } />
      </td>
      <td className="col-srvadv-weekday">
        <ServiceWeekdayPicker plan={ srv_plan } d1={ weekday1 } d2={ weekday2 } d3={ weekday3 }
          onChange={ (d,e,f)=>setWeekday(d,e,f) } />
      </td>
      <td className="col-srvadv-waxing">
        <input type="checkbox" checked={ waxing } onChange={ e=>setWaxing(e.target.checked) } />
      </td>
      <td className="col-srvadv-worker">
        <select value={worker} onChange={ e=>setWorker(parseInt(e.target.value, 10)) }>
          <option value={Data.defaultWorkerId}>{Data.defaultWorkerId} - 公司預設</option>
          { Data.wkrloc[`${srv_dis}${srv_loc}`]?.map(w=>
            <option key={`wkr-${w.uid}`} value={w.uid}>{ w.uid } - { w.name }</option>
          )}
          <option value={ori_worker}>{ori_worker} - 當前工人</option>
        </select>
      </td>
    </tr>
  );
}

export default DataGridServiceRow;
